const matchRoute = (pathname: string, regExp: string | RegExp) => new RegExp(regExp).test(pathname);

export default matchRoute;
